'use client';

import { useMemo, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import { Text, Container } from '@weareconceptstudio/core';

import { useGoogleReviews } from '@/libs/hooks';

//* Styles
import ReviewStyle from './style';

//* Components
import Rating from '../RatingAndReview/Rating';
import RatingAndReview from '../RatingAndReview';
import SkeletonSliderReview from './Skeleton';

const Review = () => {
	//! Ref
	const swiperRef = useRef();

	const { data } = useGoogleReviews();

	if (!data) {
		return <SkeletonSliderReview />;
	}
	const { success, reviews } = data;

	const reviewsList = Array.isArray(reviews) ? reviews : [];
	const last8Items = reviewsList.slice(-8);

	const itemSlide = useMemo(() => {
		if (!success || last8Items.length === 0) return null;
		return last8Items
			.filter((item) => item?.comment && item.comment.length > 10)
			.map((item, i) => (
				<SwiperSlide key={item?.reviewer?.displayName ?? i}>
					<div className='wrapper-item'>
						<Text className={'title p p3 line-clamp-10'}>{item.comment}</Text>

						<div className='wrapper-ratting-author'>
							<Rating
								showText={false}
								className={'color-reverse'}
								rate_count={item.starRating}
							/>

							<Text className={'p p4 font-montserrat-arm-bold'}>
								{item.reviewer?.displayName ?? ''}
							</Text>
						</div>
					</div>
				</SwiperSlide>
			));
	}, [reviews, success]);

	const hasSlides = last8Items.some((item) => item?.comment && item.comment.length > 10);

	return success && hasSlides ? (
		<ReviewStyle>
			<Container>
				<div className='wrapper-revive'>
					<Text
						className={'title h2 uppercase'}
						text={'yourOpinionCounts'}
					/>

					<RatingAndReview className={'color-reverse reverse button-auto'} />
				</div>
			</Container>

			<div className='outer-wrapper-swiper'>
				<Swiper
					ref={swiperRef}
					slidesPerView={'auto'}
					loop={true}
					modules={[Autoplay]}
					autoplay={false}
					onSwiper={(swiper) => {
						swiperRef.current = swiper;

						setTimeout(() => {
							if (swiper.autoplay) {
								swiper.autoplay.start();
							}
						}, 10000);
					}}>
					{itemSlide}
				</Swiper>
			</div>
		</ReviewStyle>
	) : null;
};

export default Review;
